module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/license icon-f70ea93c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/license icon.svg
// module id = ./app/web/src/assets/license icon.svg
// module chunks = 0